import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState, defaultPageSize } from '@constants';
import * as actions from '../actions/exemption';
import { SUCCESS, START, ERROR } from '../actions/global';

const initialStats = {
  taxLimitationList: { data: [], state: null },
  applytoList: { data: [], state: null },
  taxingUnitValueTypes: { data: [], state: null },
  taxingUnitList: { data: [], state: null },
  application: { data: null, state: null },
  applicationLookupModal: {
    open: false,
    mode: null,
    propertyId: null,
    state: '',
    data: [],
    selection: [],
  },
  segmentList: {
    count: 0,
    pageNum: 0,
    pageSize: defaultPageSize,
    data: [],
    state: null,
  },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.EXEMPTION_TAX_LIMITATIONS_FETCH[START]: {
      return state
        .setIn(['taxLimitationList', 'data'], fromJS([]))
        .setIn(['taxLimitationList', 'state'], fetchingState.FETCHING);
    }
    case actions.EXEMPTION_TAX_LIMITATIONS_FETCH[SUCCESS]: {
      return state
        .setIn(['taxLimitationList', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxLimitationList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.EXEMPTION_TAX_LIMITATIONS_FETCH[ERROR]: {
      return state.setIn(['taxLimitationList', 'state'], fetchingState.ERROR);
    }

    // apply to values
    case actions.APPLYTO_FETCH[START]: {
      return state
        .setIn(['applytoList', 'data'], fromJS([]))
        .setIn(['applytoList', 'state'], fetchingState.FETCHING);
    }
    case actions.APPLYTO_FETCH[SUCCESS]: {
      return state
        .setIn(['applytoList', 'state'], fetchingState.LOADED)
        .setIn(
          ['applytoList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.APPLYTO_FETCH[ERROR]: {
      return state.setIn(['applytoList', 'state'], fetchingState.ERROR);
    }

    // taxing unit value types
    case actions.FETCH_TAXING_UNIT_VALUE_TYPES[START]: {
      return state
        .setIn(['taxingUnitValueTypes', 'data'], fromJS([]))
        .setIn(['taxingUnitValueTypes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_TAXING_UNIT_VALUE_TYPES[SUCCESS]: {
      return state
        .setIn(['taxingUnitValueTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxingUnitValueTypes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_TAXING_UNIT_VALUE_TYPES[ERROR]: {
      return state.setIn(['taxingUnitValueTypes', 'state'], fetchingState.ERROR);
    }

    // taxing unit list
    case actions.EXEMPTION_TAXING_UNITS_FETCH[START]: {
      return state
        .setIn(['taxingUnitList', 'data'], fromJS([]))
        .setIn(['taxingUnitList', 'state'], fetchingState.FETCHING);
    }
    case actions.EXEMPTION_TAXING_UNITS_FETCH[SUCCESS]: {
      return state
        .setIn(['taxingUnitList', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxingUnitList', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.EXEMPTION_TAXING_UNITS_FETCH[ERROR]: {
      return state.setIn(['taxingUnitList', 'state'], fetchingState.ERROR);
    }

    // application
    case actions.EXEMPTION_APPLICATION_FETCH[START]: {
      return state
        .setIn(['application', 'data'], null)
        .setIn(['application', 'state'], fetchingState.FETCHING);
    }
    case actions.EXEMPTION_APPLICATION_FETCH[SUCCESS]: {
      return state
        .setIn(['application', 'state'], fetchingState.LOADED)
        .setIn(
          ['application', 'data'],
          fromJS(_.get(action, 'data.results.0', null)),
        );
    }
    case actions.EXEMPTION_APPLICATION_FETCH[ERROR]: {
      return state.setIn(['application', 'state'], fetchingState.ERROR);
    }

    case actions.EXEMPTION_APPLICATION_UPDATE[START]: {
      return state.setIn(['application', 'state'], fetchingState.FETCHING);
    }
    case actions.EXEMPTION_APPLICATION_UPDATE[SUCCESS]: {
      return state.setIn(['application', 'state'], fetchingState.LOADED);
    }
    case actions.EXEMPTION_APPLICATION_UPDATE[ERROR]: {
      return state.setIn(['application', 'state'], fetchingState.ERROR);
    }

    // application lookup modal
    case actions.OPEN_APPLICATION_LOOKUP_MODAL: {
      return state.set(
        'applicationLookupModal',
        fromJS({
          open: true,
          mode: action.payload.mode,
          propertyId: action.payload.propertyId,
          state: null,
          data: state.getIn(['applicationLookupModal', 'data']).toJS(),
          selection: [],
        }),
      );
    }
    case actions.CLOSE_APPLICATION_LOOKUP_MODAL: {
      return state.setIn(['applicationLookupModal', 'open'], false);
    }
    case actions.LOOKUP_APPLICATION[START]: {
      return state.setIn(
        ['applicationLookupModal', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.LOOKUP_APPLICATION[SUCCESS]: {
      return state
        .setIn(['applicationLookupModal', 'state'], fetchingState.LOADED)
        .setIn(
          ['applicationLookupModal', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.LOOKUP_APPLICATION[ERROR]: {
      return state.setIn(
        ['applicationLookupModal', 'state'],
        fetchingState.ERROR,
      );
    }
    case actions.MODAL_SELECT_APPLICATION_RECORDS: {
      return state.setIn(
        ['applicationLookupModal', 'selection'],
        action.payload,
      );
    }

    // segment list
    case actions.EXEMPTION_SEGMENTS_FETCH[START]: {
      return state
        .setIn(['segmentList', 'data'], fromJS([]))
        .setIn(['segmentList', 'state'], fetchingState.FETCHING);
    }
    case actions.EXEMPTION_SEGMENTS_FETCH[SUCCESS]: {
      return state
        .setIn(['segmentList', 'state'], fetchingState.LOADED)
        .setIn(
          ['segmentList', 'data'],
          fromJS(_.get(action, 'data.results.results', [])),
        )
        .setIn(
          ['segmentList', 'count'],
          fromJS(_.get(action, 'data.results.segmentCount', 0)),
        );
    }
    case actions.EXEMPTION_SEGMENTS_FETCH_MULTI[SUCCESS]: {
      let multiAction = JSON.parse(JSON.stringify(action));
      if (
        action &&
        action.data &&
        action.data.results &&
        action.data.results.results &&
        action.data.results.results.length > 0
      ) {
        multiAction.data.results.results = multiAction.data.results.results.map(
          r => {
            return {
              ...r,
              selected: 0,
            };
          },
        );
      }
      return state
        .setIn(['segmentList', 'state'], fetchingState.LOADED)
        .setIn(
          ['segmentList', 'data'],
          fromJS(_.get(multiAction, 'data.results.results', [])),
        )
        .setIn(
          ['segmentList', 'count'],
          fromJS(_.get(multiAction, 'data.results.segmentCount', 0)),
        );
    }
    case actions.EXEMPTION_SEGMENTS_FETCH[ERROR]: {
      return state.setIn(['segmentList', 'state'], fetchingState.ERROR);
    }
    case actions.EXEMPTION_SEGMENT_ASSOCIATE[SUCCESS]: {
      const _segment = _.get(action, 'data.results.0', {});
      return state.setIn(
        ['segmentList', 'data'],
        fromJS(
          state
            .getIn(['segmentList', 'data'])
            .toJS()
            .map(v =>
              v.pExemptionTaxingUnitSegmentID ===
              _segment.pExemptionTaxingUnitSegmentID
                ? _segment
                : v,
            ),
        ),
      );
    }
    case actions.EXEMPTION_SEGMENT_MASS_ASSOCIATE[SUCCESS]: {
      let newSegmentList = state.getIn(['segmentList', 'data']).toJS();
      for (let x = 0; x < newSegmentList.length; x++) {
        if (newSegmentList[x].segmentID === action.payload.segmentID) {
          newSegmentList[x].selected = 1;
        }
      }
      return state.setIn(['segmentList', 'data'], fromJS(newSegmentList));
    }
    case actions.EXEMPTION_BY_SEGMENT_MASS_DELETE[SUCCESS]: {
      let newSegmentList = state.getIn(['segmentList', 'data']).toJS();
      for (let x = 0; x < newSegmentList.length; x++) {
        if (newSegmentList[x].segmentID === action.payload.segmentID) {
          newSegmentList[x].selected = 0;
        }
      }
      return state.setIn(['segmentList', 'data'], fromJS(newSegmentList));
    }
    case actions.EXEMPTION_SEGMENTS_CHANGE_PAGE: {
      return state.setIn(['segmentList', 'pageNum'], action.payload);
    }
    case actions.EXEMPTION_SEGMENTS_CHANGE_PAGE_SIZE: {
      return state.setIn(['segmentList', 'pageSize'], action.payload);
    }

    default: {
      return state;
    }
  }
};
